export { chakraConfig } from './chakraConfig';
